import { extendTheme } from '@mui/material';
import { colorSchemes } from './color-schemes';
import * as components from './components';
import { customShadows, shadows } from './shadows';
import { typography } from './typography';

export const theme = extendTheme({
  cssVarPrefix: 'mex',
  colorSchemeSelector: 'data-theme',
  colorSchemes,
  typography,
  customShadows,
  defaultColorScheme: 'light',
  shadows,
  components,
  shape: {
    borderRadius: 8
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280
    }
  }
});
